module.exports = __webpack_public_path__ + "static/savings-92123b44a85c0686ae2fef3e6c0f43d9.svg";